import UserExamensModal from '@/views/parametres/examens-cliniques/modal-edit-user-examens'
export default {
    name: 'examens-cliniques',
    components: {
        UserExamensModal
    },
    props: [],
    
    data() {
        return {
            selectedUser: null,
            filter: "",
            tableIsBusy: true,
            perPage: 10,
            currentPage: 1,
            fields: [
                { key: 'index', label: 'N°' }, { key: 'name', label: "Nom" }, 
                { key: "titre", label: "Titre" }, { key: "examens", label: "Examens" }, 
                "Actions"
            ]
        }
    },

    computed: {
        usersExamens() {
            return this.$store.getters["usersExamens"];
        }

    },

    created() {
        this.$store.dispatch('getUsersMinimalist')
    },

    mounted() {

    },

    methods: {
        assignSelectedUser(user) {
            this.selectedUser = user

        }
    }
}